import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { descriptorTitle } from '@/features/rapidstor/helpers';

import type { DescriptorSwitchConfirmProps } from '../OptionSelector';

import classes from './DealRibbon.module.scss';

function DealRibbonConfirm({
    pendingSwitch,
    onConfirm,
    onCancel,
    location,
}: DescriptorSwitchConfirmProps) {
    const { t } = useTranslation();

    const descriptorName = descriptorTitle(pendingSwitch.descriptor, location)[1];

    return (
        <motion.div
            className={classes.confirmBar}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
            <div className={classes.confirmContent}>
                <div className={classes.confirmText}>
                    <span>
                        {t('deal_selector:switch_to', 'Switch to {{name}}?', { name: descriptorName })}
                    </span>
                    {!pendingSwitch.matchedDeal && (
                        <span className={classes.confirmNote}>
                            {t('deal_selector:deal_not_available', 'Deal not available for this size')}
                        </span>
                    )}
                </div>
                <div className={classes.confirmButtons}>
                    <button
                        type="button"
                        className={classes.cancelButton}
                        onClick={onCancel}
                    >
                        {t('deal_selector:cancel', 'Cancel')}
                    </button>
                    <button
                        type="button"
                        className={classes.confirmButton}
                        onClick={onConfirm}
                    >
                        {t('deal_selector:confirm_switch', 'Confirm')}
                    </button>
                </div>
            </div>
        </motion.div>
    );
}

export default DealRibbonConfirm;
